import React from 'react';
import LegalDocument from '@/components/LegalDocument';

export default function DPA() {
  return <LegalDocument document="dpa" />;
}
